
import React from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material'
import IconReusable from '../../components/IconReusable'
import { CustomButton } from '../../v2/MUI_custom_component'
import { useNavigate } from 'react-router-dom';

const policyData = [
  {
    label: 'Privacy Policy',
    // url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Privacy+Policy.pdf',
    url: '/privacy',
    iconName: 'Privacy'
  },
  {
    label: 'Refund Policy',
    // url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Refund+Policy.pdf',
    iconName: 'RefundMoney',
    url: '/refund-policy',
  },
  {
    label: 'Cancellation Policy',
    // url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Cancelation+Policy.pdf',
    iconName: 'CancelPolicy',
    url: '/cancellation-policy',
  },
  {
    label: 'Terms and Conditions',
    // url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Terms+of+Use+of+Humbee.pdf',
    iconName: 'Tnc',
    url: '/term-conditions',
  },
];

const PolicyCard = ({ iconName, iconColor, title, buttonLabel, onButtonClick, isMobile }) => (
    <Box sx={{
        display: 'flex',
        backgroundColor: '#fff',
        padding: '16px',
        borderRadius: 2,
        alignItems: 'center',
        gap: 2,
        width: '100%',
        justifyContent: 'space-between',
    }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{
                width: 32,
                height: 32,
                borderRadius: 1,
                backgroundColor: '#F7F7F7',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <IconReusable name={iconName} size={24} color={iconColor} />
            </Box>
            <Typography variant='h2'>{title}</Typography>
        </Box>
        <CustomButton
            variant='text'
            size={isMobile ? 'small' : 'medium'}
            label={buttonLabel}
            onClick={onButtonClick}
        />
    </Box>
);

const Policies = () => {
    const isMobile = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const handlePolicyClick = (url) => {
        navigate(url);
        // window.open(url, '_blank');
    };

    return (
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant='h2'>
                    Policies
                </Typography>
                <Typography variant='body1'>
                    You can view our policies below. For more details or specific queries, feel free to reach out. Our team will connect with you at the earliest.
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {policyData.map((policy, index) => (
                    <PolicyCard
                        key={index}
                        iconName={policy.iconName}
                        iconColor='#995A00'
                        title={policy.label}
                        buttonLabel='View Policy'
                        isMobile={isMobile}
                        onButtonClick={() => handlePolicyClick(policy.url)}
                    />
                ))}
            </Box>
        </Box>
    )
}

export default Policies